import React from 'react';
import { graphql } from 'gatsby';
import Image from '../components/atoms/Image';
import SEO from '../components/molecules/SEO';
import styled from 'styled-components';
import ProductGroup from '../components/organisms/ProductGroup';
import SizeGuide from '../components/molecules/SizeGuide';

const Holder = styled.article`
  text-align: justify;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
  margin-bottom: 2rem;
  @media( ${props => props.theme.breakpoints.md} ) { 
    grid-template-columns: 1fr 1fr;
    align-items: start;
    grid-auto-flow: dense;
  }
`;

const Content = styled.div`
  @media( ${props => props.theme.breakpoints.md} ) { 
    grid-row: span 2;
  }
  @media( ${props => props.theme.breakpoints.lg} ) { 
    grid-row: span 1;
  }
  h1 {
    margin-bottom: 0;
  }
  button {
    margin: 1rem 0 2rem 0;
  }
  > :first-child { margin-top: 0; }
  > :last-child { margin-bottom: 0; }
  .soldOut { ${props => props.theme.fluidType( 1 )}; }
`;

function Product( { data } ) {
  const { markdownRemark, imageSharp } = data;
  const { frontmatter, html } = markdownRemark;

  return (
    <>
      <SEO title={frontmatter.title} description={frontmatter.excerpt}/>
      <Holder>
        <Image imgName={frontmatter.hero}/>
        <Content>
          <h1>{frontmatter.title}</h1>
          <p className="h1">{`$${frontmatter.price}`}</p>
          <div dangerouslySetInnerHTML={{ __html: html }}/>
          {frontmatter.soldOut && <p className="soldOut"><b><em>Sorry, we are sold out. Sign up to the newsletter to be alerted when we restock.</em></b></p>}
          <button
            className={`snipcart-add-item`}
            disabled={frontmatter.soldOut}
            data-item-id={frontmatter.id}
            data-item-price={frontmatter.price}
            data-item-url={`https://unicornsforever.club/product/${frontmatter.id}`}
            data-item-name={`${frontmatter.title} ${frontmatter.subHead}`}
            data-item-image={imageSharp.fixed.src}
            data-item-custom1-name="Size"
            data-item-custom1-options={frontmatter.sizes}
            data-item-custom2-name={frontmatter.colours && "Colours"}
            data-item-custom2-options={frontmatter.colours}
            data-item-weight={frontmatter.weight}
            data-item-height={frontmatter.height}
            data-item-width={frontmatter.width}
            data-item-length={frontmatter.length}
          >
            Add to cart
          </button>
          {frontmatter.subHead === "Tee" && <SizeGuide/>}
        </Content>
        {frontmatter.images.map( ( image, i ) =>
          <Image key={i} imgName={image}/> )}
      </Holder>
      <ProductGroup products={data.allMarkdownRemark.nodes} title="More magic stuff"/>
    </>
  )
}

export default Product;

export const pageQuery = graphql`
    query($id: String!, $productImage: String!) {
        markdownRemark(frontmatter: { id: { eq: $id } }) {
            html
            frontmatter {
                images
                hero
                id
                postType
                price
                sizes
                colours
                subHead
                title
                weight
                height
                width
                length
                excerpt
                soldOut
            }
            excerpt(pruneLength: 150, format: PLAIN)
        }
        imageSharp(fixed: {originalName: {eq: $productImage}}) {
            fixed(fit: COVER, width: 200, height: 200) {
                src
            }
        }
        allMarkdownRemark(
            sort: {order: [ASC, DESC], fields: [frontmatter___order,frontmatter___date] }
            filter: {frontmatter: {postType: {eq: "product"}}}
        ) {
            nodes {
                frontmatter {
                    title
                    id
                    postType
                    price
                    subHead
                    closeUp
                    hero
                    excerpt
                }
            }
        }
    }
`;
